import { forwardRef } from 'react';
import { Tooltip as AntdToolTip } from 'antd';

const ToolTip = forwardRef(
	(
		{
			children,
			title,
			mouseEnterDelay,
			trigger,
			align,
			placement,
			defaultOpen,
			color,
			overlayStyle,
			overlayInnerStyle,
		},
		ref,
	) => {
		return (
			<AntdToolTip
				title={title}
				mouseEnterDelay={mouseEnterDelay}
				trigger={trigger}
				align={align}
				placement={placement ? placement : 'bottom'}
				defaultOpen={defaultOpen}
				color={color}
				overlayStyle={overlayStyle}
				overlayInnerStyle={overlayInnerStyle}
			>
				<span
					ref={ref}
					style={{ display: 'inline-flex', alignItems: 'center' }}
				>
					{children}
				</span>
			</AntdToolTip>
		);
	},
);

ToolTip.displayName = 'ToolTip';

export default ToolTip;
